import { render, staticRenderFns } from "./MerchantLocations.vue?vue&type=template&id=5c74da18&scoped=true"
import script from "./MerchantLocations.vue?vue&type=script&lang=js"
export * from "./MerchantLocations.vue?vue&type=script&lang=js"
import style0 from "./MerchantLocations.vue?vue&type=style&index=0&id=5c74da18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c74da18",
  null
  
)

export default component.exports